<div class="button-set-container">
  <button
    *ngIf="secondaryShow"
    [ngClass]="{ disabled: backDisabled }"
    class="secondary back"
    (click)="backButtonFunction()"
  >
    <img src="../../../assets/icons/arrowback.svg" />
  </button>
  <div class="right-side">
    <button
      *ngIf="tertiaryShow"
      class="tertiary"
      [ngClass]="{ disabled: tertiaryDisabled }"
      (click)="cancelButtonFunction()"
    >
      {{ tertiaryLabel | translate }}
    </button>
    <button
      *ngIf="primaryShow"
      class="primary"
      [ngClass]="{ disabled: primaryDisabled }"
      (click)="continueButtonFunction()"
    >
      {{ primaryLabel | translate }}
    </button>
  </div>
</div>
